import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/activaciones-btl")({
  component: () => <Outlet />,
});
